export default __webpack_public_path__ + "expired-staff-orange-icon.svg";